import { searchSuggestions } from '@App/api/routes/work'
import { getWorkSuggestions } from '@App/api/routes/search'
import { AutoCompleteFetchRequest } from '@App/stores/search/models/select-option-hide'

export const getClaimWorkAutoCompleteSuggestions = async ({
    property,
    searchTerm,
    rightsholderId,
    signal,
}: AutoCompleteFetchRequest) => {
    let suggestions
    if (rightsholderId) {
        suggestions = await getWorkSuggestions(rightsholderId, property, searchTerm, true, signal)
    } else {
        suggestions = await searchSuggestions(property, searchTerm, undefined, undefined, signal)
    }
    return suggestions.data || []
}
